// @flow
import React from "react";
import Icon, { type IconProps } from "../";

export default function PaymentError({ width = "68px", ...props }: IconProps) {
  return (
    <Icon viewBox="0 0 67.5 67.5" width={width} {...props}>
      <g
        fill="none"
        stroke="#ef3522"
        strokeWidth="6px"
        transform="translate(0 0)"
      >
        <circle stroke="none" cx="33.75" cy="33.75" r="33.75" />
        <circle fill="none" cx="33.75" cy="33.75" r="30.75" />
      </g>
      <g id="coins" transform="translate(13.297 14.301)">
        <path
          fill="#fcc62d"
          d="M36.53,29.211v.82c0,4.589-7.707,8.31-17.214,8.31a27.489,27.489,0,0,1-13.1-2.922c1.065,4.135,8.3,7.557,17.073,7.557,9.507,0,17.214-4.017,17.214-8.607,0-2.018-1.494-3.8-3.972-5.157"
          transform="translate(-2.099 -9.871)"
        />
        <path
          fill="#e4af18"
          d="M23.217,45.607C13.71,45.607,6,41.589,6,37v5.593c0,4.589,7.707,8.31,17.214,8.31s17.214-3.721,17.214-8.31V37c0,4.589-7.707,8.607-17.214,8.607"
          transform="translate(-2.028 -12.504)"
        />
        <path
          fill="#ce9912"
          d="M9,48.528a10.761,10.761,0,0,0,1.324,1.023V44.061A11,11,0,0,1,9,43Z"
          transform="translate(-3.041 -14.531)"
        />
        <path
          fill="#ce9912"
          d="M53,44.061V49.55a10.7,10.7,0,0,0,1.324-1.023V43A10.9,10.9,0,0,1,53,44.061"
          transform="translate(-17.911 -14.531)"
        />
        <path
          fill="#ce9912"
          d="M13,51.276q.628.325,1.324.615V46.467q-.7-.306-1.324-.646Z"
          transform="translate(-4.393 -15.485)"
        />
        <path
          fill="#ce9912"
          d="M49,51.89q.7-.29,1.324-.615V45.82q-.628.34-1.324.646Z"
          transform="translate(-16.559 -15.484)"
        />
        <path
          fill="#ce9912"
          d="M17,52.99q.642.219,1.324.41V48.028q-.682-.2-1.324-.434Z"
          transform="translate(-5.745 -16.084)"
        />
        <path
          fill="#ce9912"
          d="M45,53.4q.682-.191,1.324-.41v-5.4q-.642.231-1.324.434Z"
          transform="translate(-15.207 -16.084)"
        />
        <path
          fill="#ce9912"
          d="M22,54.358c.432.087.875.166,1.324.235V49.267c-.45-.075-.892-.158-1.324-.251Z"
          transform="translate(-7.435 -16.564)"
        />
        <path
          fill="#ce9912"
          d="M40,54.592c.45-.07.892-.148,1.324-.235V49.015c-.432.093-.875.176-1.324.252Z"
          transform="translate(-13.517 -16.564)"
        />
        <path
          fill="#ce9912"
          d="M28,55.192c.436.032.878.055,1.324.071v-5.3c-.446-.017-.888-.041-1.324-.076Z"
          transform="translate(-9.462 -16.859)"
        />
        <path
          fill="#ce9912"
          d="M34,55.263c.446-.017.888-.038,1.324-.071v-5.3c-.436.035-.878.059-1.324.077Z"
          transform="translate(-11.49 -16.859)"
        />
        <path
          fill="#e4af18"
          d="M17.217,30.6C7.71,30.6,0,26.582,0,21.993v5.593C0,32.176,7.71,35.9,17.217,35.9s17.214-3.721,17.214-8.31V21.993c0,4.589-7.707,8.607-17.214,8.607"
          transform="translate(0 -7.432)"
        />
        <path
          fill="#ce9912"
          d="M3,33.521a10.761,10.761,0,0,0,1.324,1.023V29.055A11.064,11.064,0,0,1,3,27.994v5.527Z"
          transform="translate(-1.014 -9.46)"
        />
        <path
          fill="#ce9912"
          d="M47,29.054v5.489a10.7,10.7,0,0,0,1.324-1.023V27.993A10.9,10.9,0,0,1,47,29.054"
          transform="translate(-15.883 -9.46)"
        />
        <path
          fill="#ce9912"
          d="M7,36.269q.628.325,1.324.615V31.46q-.7-.306-1.324-.646v5.455Z"
          transform="translate(-2.366 -10.413)"
        />
        <path
          fill="#ce9912"
          d="M43,36.883q.7-.29,1.324-.615V30.813q-.628.34-1.324.646Z"
          transform="translate(-14.531 -10.413)"
        />
        <path
          fill="#ce9912"
          d="M11,37.983q.642.219,1.324.41V33.021q-.682-.2-1.324-.434Z"
          transform="translate(-3.717 -11.012)"
        />
        <path
          fill="#ce9912"
          d="M39,38.393q.682-.191,1.324-.41v-5.4q-.642.231-1.324.434Z"
          transform="translate(-13.179 -11.012)"
        />
        <path
          fill="#ce9912"
          d="M16,39.351c.432.087.875.166,1.324.235V34.26c-.45-.075-.892-.158-1.324-.251Z"
          transform="translate(-5.407 -11.493)"
        />
        <path
          fill="#ce9912"
          d="M34,39.586c.45-.07.892-.148,1.324-.235V34.009c-.432.093-.875.176-1.324.252Z"
          transform="translate(-11.49 -11.493)"
        />
        <path
          fill="#ce9912"
          d="M22,40.186c.436.032.878.055,1.324.071v-5.3c-.446-.017-.888-.041-1.324-.076Z"
          transform="translate(-7.435 -11.788)"
        />
        <path
          fill="#ce9912"
          d="M28,40.256c.446-.017.888-.038,1.324-.071v-5.3c-.436.035-.878.059-1.324.077Z"
          transform="translate(-9.462 -11.788)"
        />
        <path
          fill="#ffd949"
          d="M38.48,33.3c-1.772,3.678-8.6,6.421-16.761,6.421a32.494,32.494,0,0,1-8.393-1.055c2.4,1.631,6.677,3.018,12.365,3.018,9.058,0,14.565-3.516,14.565-5.936A3.316,3.316,0,0,0,38.48,33.3"
          transform="translate(-4.502 -11.254)"
        />
        <path
          fill="#ffd949"
          d="M20.527,26.848c-9.507,0-17.214-3.721-17.214-8.31V14.8C1.234,16.1,0,17.734,0,19.566c0,4.589,7.707,8.607,17.214,8.607a27.934,27.934,0,0,0,11.817-2.411,32.377,32.377,0,0,1-8.507,1.087"
          transform="translate(0 -5)"
        />
        <path
          fill="#e4af18"
          d="M22.217,20.6C12.71,20.6,5,16.582,5,11.993v5.593c0,4.589,7.707,8.31,17.214,8.31s17.214-3.721,17.214-8.31V11.993c0,4.589-7.707,8.607-17.214,8.607"
          transform="translate(-1.69 -4.053)"
        />
        <path
          fill="#ce9912"
          d="M8,23.521a10.761,10.761,0,0,0,1.324,1.023V19.055A11.064,11.064,0,0,1,8,17.994Z"
          transform="translate(-2.703 -6.081)"
        />
        <path
          fill="#ce9912"
          d="M52,19.054v5.489a10.7,10.7,0,0,0,1.324-1.023V17.993A10.9,10.9,0,0,1,52,19.054"
          transform="translate(-17.573 -6.08)"
        />
        <path
          fill="#ce9912"
          d="M12,26.269q.628.325,1.324.615V21.46q-.7-.306-1.324-.646Z"
          transform="translate(-4.055 -7.034)"
        />
        <path
          fill="#ce9912"
          d="M48,26.883q.7-.29,1.324-.615V20.813q-.628.34-1.324.646Z"
          transform="translate(-16.221 -7.033)"
        />
        <path
          fill="#ce9912"
          d="M16,27.983q.642.219,1.324.41V23.021q-.682-.2-1.324-.434Z"
          transform="translate(-5.407 -7.633)"
        />
        <path
          fill="#ce9912"
          d="M44,28.393q.682-.191,1.324-.41v-5.4q-.642.231-1.324.434Z"
          transform="translate(-14.869 -7.633)"
        />
        <path
          fill="#ce9912"
          d="M21,29.351c.432.087.875.166,1.324.235V24.26c-.45-.075-.892-.158-1.324-.251Z"
          transform="translate(-7.097 -8.113)"
        />
        <path
          fill="#ce9912"
          d="M39,29.586c.45-.07.892-.148,1.324-.235V24.009c-.432.093-.875.176-1.324.252Z"
          transform="translate(-13.179 -8.113)"
        />
        <path
          fill="#ce9912"
          d="M27,30.186c.436.032.878.055,1.324.071v-5.3c-.446-.017-.888-.041-1.324-.076Z"
          transform="translate(-9.124 -8.409)"
        />
        <path
          fill="#ce9912"
          d="M33,30.256c.446-.017.888-.038,1.324-.071v-5.3c-.436.035-.878.059-1.324.077Z"
          transform="translate(-11.152 -8.408)"
        />
        <path
          fill="#fcc62d"
          d="M39.43,7.945c0,4.589-7.707,8.607-17.214,8.607S5,12.534,5,7.945,12.71,0,22.217,0,39.43,3.355,39.43,7.945"
          transform="translate(-1.69)"
        />
        <path
          fill="#ffd949"
          d="M23.568,14.895C14.51,14.895,9,11.379,9,8.959S14.51,3,23.568,3,38.134,6.539,38.134,8.959s-5.507,5.936-14.565,5.936"
          transform="translate(-3.041 -1.014)"
        />
      </g>
      <line
        fill="none"
        stroke="#ef3522"
        strokeWidth="6px"
        x1="47.582"
        y2="43.156"
        transform="translate(9.406 11.619)"
      />
    </Icon>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Tournaments/PaymentError.js